// Copyright (c) 2023 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {resetDuplicatePinPlate, updateDuplicatePinPlate} from './duplicate-pin-plate';
import {
    createDuplicatePinPlate
} from '../../../product/shared/repositories';
import {generateTemporaryObjectKey} from '../../../shared/services/generate-temporary-object-key';
import {
    successAlertBar
} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateTemporaryObjectKey} from './update-temporary-object-key';

export const handleDuplicatePinPlateSubmit = duplicatePinPlate =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const attachmentID = duplicatePinPlate.file[0] ? duplicatePinPlate.file[0].serialNumber : '';

            duplicatePinPlate.id = attachmentID;
            await createDuplicatePinPlate(duplicatePinPlate);

            successAlertBar(translate('DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED'));

            resetDuplicatePinPlate()(dispatch);
            updateDuplicatePinPlate('dateSubmmited', Date.now())(dispatch);
            updateTemporaryObjectKey(generateTemporaryObjectKey())(dispatch);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/action-creators/handle-submit.js